import { gql } from '@apollo/client';

export const BULK_DELETE_USER_TYPES_MUTATION = gql`
  mutation deleteRoles($userTypeIds: [Int]!) {
    userType {
      bulkDelete(userTypeIds: $userTypeIds)
    }
  }
`;
